<template>
  <a class="menu-entry button flex flex--row flex--align-center" href="javascript:void(0)">
    <div class="menu-entry__icon flex flex--column flex--center">
      <slot name="icon"></slot>
    </div>
    <div class="menu-entry__text flex flex--column">
      <slot></slot>
    </div>
  </a>
</template>

<style lang="scss">
@use 'sass:color';
@import '../../../styles/variables.scss';

.menu-entry {
  display: flex !important;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: left !important;
  padding: 6px 10px;
  height: auto;
  font-size: 14px;
  line-height: 1.3;
  text-transform: none;
  white-space: normal;
  color: rgba(0, 0, 0, 0.87);

  .app--dark & {
    color: rgba(255, 255, 255, 0.87);
  }

  span {
    display: inline-block;
    font-size: 0.65rem;
    opacity: 0.67;
    line-height: 1.2;

    .menu-entry__label {
      opacity: 1;
    }

    span {
      display: inline;
      opacity: 1;
    }
  }
}

.menu-entry--info {
  padding-top: 3px;
  padding-bottom: 3px;
}

.menu-entry__icon {
  height: 16px;
  width: 16px;
  min-width: 16px;
  margin-right: 8px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon,
  .icon-provider {
    width: 16px;
    height: 16px;
  }
}

.menu-entry__icon--disabled {
  opacity: 0.5;
}

.menu-entry__icon--image {
  border-radius: $border-radius-base;
  overflow: hidden;
}

.hidden-file {
  position: fixed;
  top: -999px;
}

.menu-entry__label {
  float: right;
  font-size: 0.6rem;
  font-weight: 600;
  line-height: 1;
  padding: 0.15em 0.25em;
  background-color: #fff;
  border-radius: 3px;
  opacity: 0.6;
}

.menu-entry__label--warning {
  color: #fff;
  background-color: color.adjust($error-color, $lightness: -10%);
  opacity: 1;
}

.menu-entry__label--count {
  font-size: 0.75rem;
  font-weight: 400;
}

.menu-entry__text {
  width: 100%;
  overflow: hidden;
}
</style>
